import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { graphql } from "gatsby"

import Layout from "../components/Layout"
import Content, { HTMLContent } from "../components/Content"
import FeaturedBanner from "../components/FeaturedBanner"
import BlogTagLinks from "../components/BlogTagLinks"
import {
  ContentBox,
  ContentBoxTitle,
} from "../styles/styled-components/styledComponents"

const FeaturedPostTemplate = ({
  content,
  contentComponent,
  tags,
  helmet,
}) => {
  const PostContent = contentComponent || Content

  return (
    <div>
      {helmet || ""}
      <section className="section">
        <div className="container content">
          <div className="columns">
            <div className="column is-10 is-offset-1">
              <PostContent className="content" content={content} />
              <ContentBox className="box">
                <ContentBoxTitle>Tags for this post</ContentBoxTitle>
                <BlogTagLinks tags={tags} />
              </ContentBox>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

FeaturedPostTemplate.propTypes = {
  content: PropTypes.object.isRequired,
  contentComponent: PropTypes.func,
  helmet: PropTypes.object,
  title: PropTypes.string,
  tags: PropTypes.array,
}

const FeaturedPost = ({ data }) => {
  const { markdownRemark: post } = data

  return (
    <Layout>
      <FeaturedBanner
        image={post.frontmatter.bannerImage}
        title={post.frontmatter.title}
        subtitle={post.frontmatter.subtitle}
      />
      <FeaturedPostTemplate
        content={post}
        contentComponent={HTMLContent}
        title={post.frontmatter.title}
        tags={post.frontmatter.tags}
        helmet={
          <Helmet titleTemplate="%s | Looking For Sponsor">
            <title>{`${
              post.frontmatter.subtitle
                ? post.frontmatter.subtitle
                : "Featured Sponsorship"
            }: ${post.frontmatter.title}`}</title>
            <meta
              name="description"
              content={`${post.frontmatter.description}`}
            />

            <meta
              property="og:title"
              content={`${
                post.frontmatter.subtitle
                  ? post.frontmatter.subtitle
                  : "Become a Sponsor"
              }: ${post.frontmatter.title}`}
            />
            <meta
              property="og:description"
              content={post.frontmatter.description}
            />
            <meta property="og:type" content="article" />
            <meta property="og:image" content={post.frontmatter.ogImage} />
            <meta property="og:url" content={post.frontmatter.ogUrl} />

            <meta name="twitter:card" content="summary" />
            <meta
              name="twitter:title"
              content={`${
                post.frontmatter.subtitle
                  ? post.frontmatter.subtitle
                  : "Become a Sponsor"
              }: ${post.frontmatter.title}`}
            />
            <meta
              name="twitter:description"
              content={post.frontmatter.description}
            />
            <meta name="twitter:image" content={post.frontmatter.ogImage} />
          </Helmet>
        }
      />
    </Layout>
  )
}

FeaturedPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
}

export default FeaturedPost
export const pageQuery = graphql`
  query FeaturedPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      htmlAst
      frontmatter {
        title
        subtitle
        date(formatString: "MMMM DD, YYYY")
        description
        tags
        ogImage
        ogUrl
        bannerImage {
          childImageSharp {
            fluid(maxWidth: 2048, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
